import RegisterFunnelDailyFilter from "@/pages/dashboard/filterPageComponents/funnel/registerFunnelDailyFilter";
import MetricsCardTitle from "@/pages/dashboard/components/MetricsCardTitle";
import FunnelCardContent from "@/pages/dashboard/pages/funnel/registerFunnelDaily/component/FunnelCardContent";
import FunnelCardService from "@/pages/dashboard/pages/funnel/registerFunnelDaily/component/FunnelCardService";
import FunnelStepCard from "@/pages/dashboard/pages/funnel/registerFunnelDaily/component/FunnelStepCard";
import FunnelStepCardService from "@/pages/dashboard/pages/funnel/registerFunnelDaily/component/FunnelStepCard/FunnelStepCardService";
import FunnelTableService from "@/pages/dashboard/pages/funnel/registerFunnelDaily/component/FunnelTableService";
import FunnelTable from "@/pages/dashboard/pages/funnel/components/FunnelTable";
import FunnelStepCardContext from "@/pages/dashboard/pages/funnel/registerFunnelDaily/component/FunnelStepCard/FunnelStepCardContext";
import AdFunnelTrendStep from "@/pages/dashboard/pages/funnel/components/TrendStep";


export default {
  RegisterFunnelDailyFilter,
  FunnelStepCardService,
  MetricsCardTitle,
  FunnelStepCard,
  FunnelStepCardContext,
  FunnelCardService,
  FunnelCardContent,
  FunnelTableService,
  FunnelTable,
  AdFunnelTrendStep,
};